// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"3d0983bfe1cbb6f26200","883":"5661fb6c60e7b2d2b853"}[chunkId] + ".js";
};